import(/* webpackMode: "eager" */ "/vercel/path0/apps/ocnc/app/fantasy/page.tsx");
